import { EventType, ErrorCode } from "../commons/Constants";

// Re-export for Yahoo module consumers
export { EventType, ErrorCode };
import postEvent, { createBaseLanderEvent } from "../commons/LanderEvent";
import { Settings } from "../config";

export interface YahooEventOptions {
  yahooApiMessage?: string;
  errorCode?: string;
  rsTerms?: string;
  /** Comma-joined row origins, positionally aligned with `rsTerms`. */
  rsOrigins?: string;
  /** Origin of the single row that was clicked. */
  rsOrigin?: string;
  searchQuery?: string;
  categoryRating?: string;
  /**
   * PARKING-5307: whether the API's LLM keywords were shown to the visitor in
   * this event's rows. Pass it only where that is known (RS_LOAD, and
   * KEYWORD_CLICK on a related-search row); leave it out everywhere else, and
   * the event carries no such field. Sent as true/false (false is kept) and only
   * while LLM_KEYWORDS_ENABLED is on.
   */
  llmKeywordsUsed?: boolean;
}

export function sendYahooEvent(
  eventType: string,
  landerConfig: any,
  options?: YahooEventOptions
) {
  const yahooEvent = createBaseLanderEvent(eventType, landerConfig);

  if (options?.yahooApiMessage) {
    yahooEvent.yahooApiMessage = options.yahooApiMessage;
  }
  if (options?.errorCode) {
    yahooEvent.errorCode = options.errorCode;
  }
  if (options?.rsTerms) {
    yahooEvent.rsTerms = options.rsTerms;
  }
  if (options?.rsOrigins) {
    yahooEvent.rsOrigins = options.rsOrigins;
  }
  if (options?.rsOrigin) {
    yahooEvent.rsOrigin = options.rsOrigin;
  }
  if (options?.searchQuery) {
    yahooEvent.searchQuery = options.searchQuery;
  }
  if (options?.categoryRating) {
    yahooEvent.categoryRating = options.categoryRating;
  }
  if (
    Settings.LLM_KEYWORDS_ENABLED &&
    typeof options?.llmKeywordsUsed === "boolean"
  ) {
    yahooEvent.llmKeywordsUsed = options.llmKeywordsUsed;
  }

  postEvent(Settings.EVENT_PUBLISH_API, yahooEvent);
}
